var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { DEFAULT_ICON_FILL, DEFAULT_ICON_ROLE, DEFAULT_ICON_SPIN, ICON_FILL_PREFIX, ICON_PREFIX, ICON_SLUG_CLASS, ICON_SLUG_SELECTOR, sprite, ICON_FOLDER } from '../lib-iconsvg';
import { componentApi } from '../component-api-lib';
import * as React from 'react';
var Iconsvg = /** @class */ (function (_super) {
    __extends(Iconsvg, _super);
    function Iconsvg(props) {
        var _this = _super.call(this, props) || this;
        _this.writeState = componentApi.writeState.bind(_this);
        _this.iconWrapperElementRef = React.createRef();
        _this.iconElementRef = React.createRef();
        _this.iconCdnElementRef = React.createRef();
        _this.iconWrapperElement = function () {
            return _this.iconWrapperElementRef
                ? _this.iconWrapperElementRef.current
                : null;
        };
        _this.iconElement = function () {
            return _this.iconElementRef ? _this.iconElementRef.current : null;
        };
        _this.iconCdnElement = function () {
            return _this.iconCdnElementRef ? _this.iconCdnElementRef.current : null;
        };
        _this.isIconSpritesRendered = function () {
            var _a;
            var node = _this.iconElement();
            return !!(node && ((_a = node.ownerDocument) === null || _a === void 0 ? void 0 : _a.querySelector(ICON_SLUG_SELECTOR)));
        };
        _this.state = {};
        _this.state['isInitialRender'] = true;
        return _this;
    }
    Iconsvg.prototype.render = function () {
        return (React.createElement("span", { ref: this.iconWrapperElementRef, "data-e2e": this.props.dataE2e, className: "cg-icon" },
            !this.isCdn() ? (React.createElement("svg", { ref: this.iconElementRef, xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", "icon-name": this.getIconName(), focusable: "false", role: this.getRole(), width: "1em", height: "1em" },
                React.createElement("title", null, this.props.title || this.props.caption),
                this.props.name ? React.createElement("use", { href: this.getLink() }) : null,
                !this.props.name ? (React.createElement(React.Fragment, null, this.props.children)) : null)) : null,
            this.props.name && this.isCdn() ? (React.createElement("span", { ref: this.iconCdnElementRef, "data-e2e": "cg-icon-ssr", "aria-hidden": "true", role: this.getRole(), "icon-name": this.getIconName(), className: "cg-icon-cdn" })) : null));
    };
    Iconsvg.prototype.isCdn = function () {
        return this.props.isSsr || this.props.hasCdnSource;
    };
    Iconsvg.prototype.cg_change = function (prevProps) {
        if (prevProps.isInitialRender &&
            !this.state.isInitialRender &&
            !this.isIconSpritesRendered()) {
            var iconConstructor = this.constructor;
            if (!iconConstructor.shouldLoadAllSprites) {
                return;
            }
            this.injectSpriteAndHideIt();
        }
        if (this.isPropChanged(prevProps, 'size') ||
            this.isPropChanged(prevProps, 'name') ||
            this.isPropChanged(prevProps, 'title') ||
            this.isPropChanged(prevProps, 'isFill') ||
            this.isPropChanged(prevProps, 'color') ||
            this.isPropChanged(prevProps, 'isSpin') ||
            this.isPropChanged(prevProps, 'isSsr') ||
            this.isPropChanged(prevProps, 'hasCdnSource')) {
            this.updateStyles();
        }
    };
    Iconsvg.prototype.isPropChanged = function (prevProps, propName) {
        return (propName in prevProps &&
            prevProps[propName] !== this.props[propName]);
    };
    Iconsvg.prototype.getAnimation = function () {
        return this.getIsSpin() ? 'cg-spin 2s infinite linear' : null;
    };
    Iconsvg.prototype.getLink = function () {
        return "#".concat(ICON_PREFIX, "-") + this.getIconName();
    };
    Iconsvg.prototype.getMask = function () {
        var resultName = (this.props.name || this.props.title);
        if (resultName === 'privacy-options') {
            return "url(https://cdn.wolterskluwer.io/wk/fundamentals/2.x.x/icons/assets/compliance/0100-ccpa/privacy-options.svg)";
        }
        return "url(https://cdn.wolterskluwer.io/wk/jumpstart-v3-assets/0.x.x/icons/functional/".concat(this.getMode(), "/").concat(this.getFolder(), "/").concat(this.getIconName(), ".svg)");
    };
    Iconsvg.prototype.getMode = function () {
        return this.getIsFill() ? 'filled' : 'open';
    };
    Iconsvg.prototype.getFolder = function () {
        var resultName = (this.props.name || this.props.title);
        return ICON_FOLDER[resultName];
    };
    Iconsvg.prototype.getIconName = function () {
        var fill = this.getIsFill() && !this.isCdn() ? "".concat(ICON_FILL_PREFIX, "-") : '';
        var resultName = this.props.name || this.props.title || '';
        return "".concat(fill).concat(resultName);
    };
    Iconsvg.prototype.getSize = function () {
        return this.props.size ? this.props.size + 'px' : null;
    };
    Iconsvg.prototype.getIsSpin = function () {
        return this.props.isSpin || DEFAULT_ICON_SPIN;
    };
    Iconsvg.prototype.getIsFill = function () {
        if (!this.props.name) {
            return false;
        }
        return this.props.isFill || DEFAULT_ICON_FILL;
    };
    Iconsvg.prototype.getRole = function () {
        return this.props.role || this.props.srRole || DEFAULT_ICON_ROLE;
    };
    Iconsvg.prototype.getColor = function () {
        return this.props.color
            ? this.props.color
            : this.isCdn()
                ? 'currentColor'
                : null;
    };
    Iconsvg.prototype.injectSpriteAndHideIt = function () {
        var div = document.createElement('div');
        div.innerHTML = "".concat(sprite);
        div.id = ICON_SLUG_CLASS;
        div.style.display = 'none';
        this.iconElement().ownerDocument.body.appendChild(div);
    };
    Iconsvg.prototype.updateStyles = function () {
        this.iconWrapperElement().style.fontSize = this.getSize();
        this.updateIconCdnElementStyles();
        this.updateIconElementStyles();
    };
    Iconsvg.prototype.updateIconCdnElementStyles = function () {
        if (this.iconCdnElement()) {
            var mask = this.getMask();
            this.iconCdnElement().style.width = '1em';
            this.iconCdnElement().style.height = '1em';
            this.iconCdnElement().style.display = 'inline-block';
            this.iconCdnElement().style.backgroundColor = this.getColor();
            this.iconCdnElement().style.animation = this.getAnimation();
            this.iconCdnElement().style.mask = mask;
            this.iconCdnElement().style['-webkitMask'] = mask;
        }
    };
    Iconsvg.prototype.updateIconElementStyles = function () {
        if (this.iconElement()) {
            this.iconElement().style.width = '1em';
            this.iconElement().style.height = '1em';
            this.iconElement().style.color = this.getColor();
            this.iconElement().style.animation = this.getAnimation();
        }
    };
    Iconsvg.prototype.componentDidMount = function () {
        if (this.props.name && this.props.name.includes('filled')) {
            console.warn("Icon: ".concat(this.props.name, ". Please use property \"isFill=true\" instead of icon name with \"filled-\" prefix."));
        }
        if (this.props.isSsr) {
            console.warn('Icon: property "isSsr" is deprecated, please use "hasCdnSource" instead.');
        }
        if (!this.isCdn() && this.state.isInitialRender) {
            // isInitialRender state is required to prevent rehydration error in React,
            // once the component is initialized we can inject the sprite
            this.writeState('isInitialRender', false);
        }
        this.updateStyles();
    };
    Iconsvg.prototype.componentDidUpdate = function (prevProps, prevState) {
        this.cg_change(__assign(__assign({}, prevProps), prevState));
    };
    Iconsvg.defaultProps = {
        dataE2e: 'cg-icon',
        isSpin: DEFAULT_ICON_SPIN,
        isFill: DEFAULT_ICON_FILL,
        role: DEFAULT_ICON_ROLE,
        srRole: DEFAULT_ICON_ROLE,
        isSsr: false,
        hasCdnSource: false,
    };
    Iconsvg.displayName = 'Iconsvg';
    Iconsvg.shouldLoadAllSprites = true;
    return Iconsvg;
}(React.Component));
export { Iconsvg };
